<template>
  <div class="container">
    <nav aria-label="breadcrumb" v-cloak>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="/">{{ $t('home') }}</a>
        </li>
        <li class="breadcrumb-item active" v-cloak aria-current="page">
          {{ currentRout }}
        </li>
      </ol>
    </nav>
    <h1 v-cloak class="mb-2">{{ currentRout }}</h1>
    <div class="row" v-cloak>
      <div class="col-12 col-lg-4 col-xl-3">
        <div class="box-block box-block_sm sticky-sidebar">
          <!-- <div
            v-cloak
            v-if="clientType == 3 || clientType == 4 || clientType == 5"
          >
            <span class="icon icon-wfsa" />
          </div> -->
          <h4 v-if="isLoaded" class="mt-2 mb-0">{{ fullName }}</h4>
          <div v-if="isLoaded" class="text-muted text-small">{{ email }}</div>
          <h4
            v-if="
              isLoaded &&
              clientType != 1 &&
              clientType !== 'trainee' &&
              companyName != 'allCompanies'
            "
            class="mt-2 mb-0"
          >
            {{ $t(companyName) }}
          </h4>
          <div
            v-if="isLoaded && clientType != 1 && clientType !== 'trainee'"
            class="text-muted text-small"
          >
            {{ companyRef }}
          </div>
          <h4
            v-if="
              isLoaded &&
              clientType !== 'trainee' &&
              clientType != 1 &&
              establishmentTitle != 'allEstablishment'
            "
            class="mt-2 mb-0"
          >
            {{ $t(establishmentTitle) }}
          </h4>
          <div
            v-if="isLoaded && clientType != 1 && clientType !== 'trainee'"
            class="text-muted text-small"
          >
            {{ establishmentInternalCode }}
          </div>
          <h4
            v-if="isLoaded && clientType === 'trainee' && user.companyTitle"
            class="mt-2 mb-0"
          >
            {{ user.companyTitle }}
          </h4>
          <div
            v-if="
              isLoaded && clientType === 'trainee' && user.establishmentTitle
            "
            class="mt-1 text-muted text-small"
          >
            {{ user.establishmentTitle }}
          </div>
          <div v-if="clientType === 'trainee'" class="profile-menu mt-4">
            <router-link
              @click.stop.prevent
              to="/my-account"
              class="profile-menu"
              active-class="profile-menu__active"
              replace
            >
              {{ $t('myAccount') }}
            </router-link>
            <router-link
              @click.stop.prevent
              to="/trainee-registrations"
              class="profile-menu"
              active-class="profile-menu__active"
            >
              {{ $t('myTrainings') }}
            </router-link>
            <router-link
              @click.stop.prevent
              to="/trainee-habilitations"
              class="profile-menu"
              active-class="profile-menu__active"
              replace
            >
              {{ $t('habilitations') }}
            </router-link>
            <router-link
              @click.stop.prevent
              to="/trainee-results"
              class="profile-menu"
              active-class="profile-menu__active"
            >
              {{ $t('myResults') }}
            </router-link>
            <a href="/" @click="logout">
              {{ $t('logout') }}
            </a>
          </div>
          <div v-else class="profile-menu mt-4">
            <router-link
              v-if="clientType != 1"
              @click.stop.prevent
              to="/my-companies"
              class="profile-menu"
              active-class="profile-menu__active"
              replace
              >{{ $t('myCompanies') }}
            </router-link>
            <router-link
              v-if="clientType != 1"
              @click.stop.prevent
              to="/my-team"
              class="profile-menu"
              active-class="profile-menu__active"
              :disabled="!company || (company && !company.id)"
              >{{ $t('myTeam') }}
            </router-link>
            <router-link
              v-if="clientType != 1 && clientType != 2"
              @click.stop.prevent
              to="/my-training-plan"
              class="profile-menu"
              active-class="profile-menu__active"
              :disabled="
                !company ||
                (company && !company.id) ||
                !establishment ||
                (establishment && !establishment.id)
              "
              >{{ $t('myTrainingPlan') }}
            </router-link>
            <router-link
              @click.stop.prevent
              to="/registrations"
              class="profile-menu"
              :disabled="
                clientType != 1 &&
                (!company ||
                  (company && !company.id) ||
                  !establishment ||
                  (establishment && !establishment.id))
              "
              active-class="profile-menu__active"
              >{{ clientType === 1 ? $t('myTrainings') : $t('registrations') }}
            </router-link>
            <router-link
              @click.stop.prevent
              to="/my-sessions"
              class="profile-menu"
              active-class="profile-menu__active"
              :disabled="user.clientType != 2 && user.clientType != 1"
              >{{ $t('mySessions') }}
            </router-link>
            <router-link
              v-if="clientType == 1 || clientType == 2"
              @click.stop.prevent
              to="/my-invoices"
              class="profile-menu"
              :disabled="
                clientType != 1 && (!company || (company && !company.id))
              "
              active-class="profile-menu__active"
              >{{ $t('myInvoices') }}
            </router-link>
            <router-link
              v-if="
                clientType != 1 &&
                clientType != 2 &&
                permission('view-monitoring')
              "
              @click.stop.prevent
              to="/my-monitoring"
              class="profile-menu"
              active-class="profile-menu__active"
              :disabled="!company || (company && !company.id)"
              >{{ $t('myMonitoring') }}
            </router-link>
            <router-link
              v-if="
                clientType != 1 &&
                clientType != 2 &&
                permission('view-habilitations')
              "
              @click.stop.prevent
              to="/habilitations"
              class="profile-menu"
              active-class="profile-menu__active"
              :disabled="!company || (company && !company.id)"
              >{{ $t('habilitations') }}
            </router-link>
            <router-link
              @click.stop.prevent
              to="/results"
              class="profile-menu"
              active-class="profile-menu__active"
              :disabled="
                clientType != 1 &&
                (!company ||
                  (company && !company.id) ||
                  !establishment ||
                  (establishment && !establishment.id))
              "
            >
              {{ $t('myResults') }}
            </router-link>
            <router-link
              @click.stop.prevent
              to="/my-account"
              class="profile-menu"
              active-class="profile-menu__active"
              replace
              >{{ $t('myAccount') }}
            </router-link>
            <a href="/" @click="logout">{{ $t('logout') }}</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-8 col-xl-9">
        <div v-if="isLoaded" class="h-100">
          <router-view></router-view>
        </div>
        <div v-else class="h-100">
          <div
            class="h-100 row d-flex justify-content-center align-items-center"
          >
            <div class="col-12">
              <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

export default {
  name: 'Profile',
  data() {
    return {
      companyName: '',
      companyRef: '',
      establishmentTitle: '',
      establishmentInternalCode: '',
      isLoaded: false,
      password: null,
      confirmed: null,
      matchPassword: true,
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields([
      'cart',
      'user',
      'company',
      'establishment',
      'establishments',
    ]),
    ...mapGetters(['isLoggedIn']),
    fullName() {
      if (this.user) {
        return this.user.firstname + ' ' + this.user.lastname
      }
      return
    },
    email() {
      if (this.user) {
        return this.user.email
      }
    },
    clientType() {
      return this.$lodash.get(this.user, 'clientType', 1)
    },
    currentRout() {
      let r = ''
      switch (this.$route.name) {
        case 'MyTeam':
          r = this.$t('myTeam')
          break
        case 'MyTrainingPlan':
          r = this.$t('myTrainingPlan')
          break
        case 'MyCompanies':
          r = this.$t('myCompanies')
          break
        case 'MyAccount':
          r = this.$t('myAccount')
          break
        case 'MySessions':
          r = this.$t('mySessions')
          break
        case 'MyInvoices':
          r = this.$t('myInvoices')
          break
        case 'TraineeRegistrations':
          r = this.$t('myTrainings')
          break
        case 'Registrations':
          r =
            this.clientType === 1
              ? this.$t('myTrainings')
              : this.$t('registrations')
          break
        case 'TraineeHabilitations':
        case 'Habilitations':
          r = this.$t('habilitations')
          break
        case 'MyMonitoring':
          r = this.$t('myMonitoring')
          break
        case 'TraineeResults':
        case 'Results':
          r = this.$t('results')
          break
      }
      return r
    },
  },
  watch: {
    company: {
      handler(newValue, oldValue) {
        this.companyName = this.$lodash.get(newValue, 'title', '')
        this.companyRef = this.$lodash.get(newValue, 'internalCode', '')
        this.establishments = this.$lodash.get(
          newValue,
          'establishments.data',
          []
        )
        this.establishmentTitle = this.$lodash.get(
          newValue,
          'establishments.data[0].title',
          ''
        )
        this.establishmentInternalCode = this.$lodash.get(
          newValue,
          'establishments.data[0].internalCode',
          ''
        )
      },
      deep: true,
      immediate: true,
    },
    establishment: {
      handler(newValue, oldValue) {
        this.establishmentTitle = this.$lodash.get(newValue, 'title', '')
        this.establishmentInternalCode = this.$lodash.get(
          newValue,
          'internalCode',
          ''
        )
      },
      deep: true,
    },
  },
  created() {
    let apiBaseURL = document.head.querySelector('meta[name="api-baseurl"]')
    this.$store.commit('SET_API_BASEURL', apiBaseURL.content)

    const payload = {
      includes: [
        'trainees', // see last Hanen's comment in ticket: 1396196408. We can't exclude it because sessions page doesn't work.
        // 'newsletters',
        'sessions', // see last Hanen's comment in ticket: 1396196408. We can't exclude it because sessions page doesn't work.
        // 'toClients.clients'
      ],
    }

    if (this.user.clientType !== 'trainee') {
      this.$store.dispatch('getAccountInformations', payload).then((data) => {
        this.isLoaded = true
        this.$store.dispatch('getNewsletters')
      })
    } else {
      this.isLoaded = true
    }

    if (!this.isLoggedIn) {
      window.location = '/'
    }
  },
  mounted() {
    let companies = this.$lodash.get(this.user, 'toClients.data', [])
    if (this.company && this.establishment) {
      this.companyName = this.$lodash.get(this.company, 'title', '')
      this.companyRef = this.$lodash.get(this.company, 'internalCode', '')
      this.establishmentTitle = this.$lodash.get(
        this.establishment,
        'title',
        ''
      )
      this.establishmentInternalCode = this.$lodash.get(
        this.establishment,
        '.internalCode',
        ''
      )
    }
  },
  methods: {
    permission(perm) {
      const establishmentId =
        this.$lodash.get(this.establishment, 'id', false) || -1
      const establishment = this.user.permissions.find(
        (i) => i.establishment.id === establishmentId
      )
      return establishment ? Boolean(establishment.establishment[perm]) : false
    },
    clearCart() {
      this.$store.commit('CLEAR_CART')
      this.$store.commit('SET_STEP', 0)
    },
    logout() {
      window.location = '/'
      this.user = null
      this.clearCart()
      this.$store.commit('SET_COMPANY', {
        id: null,
        internalCode: '',
        establishments: {
          data: [
            {
              id: null,
              internalCode: '',
              title: 'allEstablishment',
            },
          ],
        },
        ref: 1,
        title: 'allCompanies',
      })
      this.$store.commit('SET_ESTABLISHMENT', {
        id: null,
        internalCode: '',
        title: 'allEstablishment',
      })
    },
  },
}
</script>

<style></style>
